import Date_ from './Date_'

export default class AfterOrEqual extends Date_ {
  get ruleName () {
    return 'afterOrEqual'
  }

  passes () {
    return this.momentFormat(this.value).isSameOrAfter(this.momentFormat(this.date), 'd')
  }
}
